import script from "./BookingStepsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingStepsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BookingStepsHeader.vue?vue&type=style&index=0&id=6e49abe3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e49abe3"]])

export default __exports__